import * as React from 'react';
/**
 * @hidden
 */
export var BarcodeContext = React.createContext(null);
BarcodeContext.displayName = 'BarcodeContext';
